import axios from "axios";
import { Metadados } from "../classes/Metadados";

const DEFAULT_STATE = {
    estrutura: [],
    artigo: {},
    analises: new Map(),
    optiToken: "",
    analiseSeo: {},
    blogIdOpti: 0,
    usuarioIdOpti: 0,
    updatingEstrutura: false,
    updatingSEO: false,
    meta: new Metadados({}),
    userLoggedIn: null,
};

export default function reducer(state = DEFAULT_STATE, action) {
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    let analise;
    switch (action.type) {
        case 'SET_ESTRUTURA':
            return {
                ...state,
                estrutura: action.estrutura,
            };
        case 'SET_ARTIGO':
            return {
                ...state,
                artigo: action.artigo,
            };
        case 'ADD_ANALISE':
            analise = state.analises
            analise.set(action.analise.chave, action.analise.valor)
            return {
                ...state,
                analises: analise
            };
        case 'SET_STATUS_ESTRUTURA':
            return {
                ...state,
                updatingEstrutura: action.status,
            };
        case 'SET_STATUS_SEO':
            return {
                ...state,
                updatingSEO: action.status,
            };
        case 'SET_ANALISE_SEO':
            return {
                ...state,
                analiseSeo: action.analiseSeo,
            };
        case 'SET_TOKEN_OPTI':
            return {
                ...state,
                optiToken: action.tokenOpti,
            };
        case 'SET_BLOG_ID_OPTI':
            return {
                ...state,
                blogIdOpti: action.blogIdOpti,
            };
        case 'SET_USUARIO_ID_OPTI':
            return {
                ...state,
                usuarioIdOpti: action.usuarioIdOpti,
            };
        case 'SET_RESULT_SEO':
            return {
                ...state,
                resultSeo: action.resultSeo,
            };
        case 'SET_KEYWORD':
            return {
                ...state,
                keyword: action.keyword,
            };
        case 'GUARDAR_META_DADOS':
            return {
                ...state,
                meta: action.meta,
            };
        case 'SET_USER_LOGGED_IN':
            return { ...state, userLoggedIn: action.payload };
    }

    return state;
}